import { render, staticRenderFns } from "./Abbreviation.vue?vue&type=template&id=81d8a384"
import script from "./Abbreviation.vue?vue&type=script&lang=js"
export * from "./Abbreviation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports